import { css } from 'styled-components';
var selectBoxData = {
  name: 'selectBox',
  data: [],
  onlyTemplate: {
    pro: css([".c7n-pro-select-box-float-label.c7n-pro-select-box-multiple .c7n-pro-select-box,.c7n-pro-select-box-float-label:not(.c7n-pro-select-box-multiple) .c7n-pro-select-box{min-height:unset;}"])
  }
};
export default selectBoxData;